import { Component } from '@angular/core';

@Component({
    selector: 'stby-loader-dots',
    templateUrl: './loader-dots.html',
    styleUrl: './loader-dots.scss',
})
export class LoaderDots {}
